module.exports = __webpack_public_path__ + "img/cs5.12064366.png";